/* eslint-disable */
import {
  COPARTICIPATION_API_BASE,
  COPARTICIPATION_ENDPOINTS,
  COPARTICIPATION_FILTER_API_BASE,
} from '@/store/modules/coparticipation/coparticipation-config';
import { store as observableStore } from '@/shared/observable/store';
import HttpService from '../HttpService';

let suppressedDialogRequests = 0;
let previousCustomDialogState = false;

const withSuppressedGlobalErrorDialog = async (request) => {
  if (suppressedDialogRequests === 0) {
    previousCustomDialogState = observableStore.isCustomDialog;
    observableStore.isCustomDialog = true;
  }
  suppressedDialogRequests += 1;

  try {
    return await request();
  } finally {
    suppressedDialogRequests -= 1;
    if (suppressedDialogRequests === 0) {
      observableStore.isCustomDialog = previousCustomDialogState;
    }
  }
};

const buildQuery = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') return;
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== null && item !== undefined && item !== '') {
          searchParams.append(key, item);
        }
      });
      return;
    }

    searchParams.append(key, value);
  });

  const query = searchParams.toString().replace(/%2C/gi, ',');
  return query ? `?${query}` : '';
};

const normalizePaginatedResponse = (response) => {
  const data = response?.data ?? response ?? {};
  const rawContent = Array.isArray(data.content) ? data.content : [];
  const content = rawContent.map((item) => ({
    id: item.id ?? item.carrierId ?? item.contractId,
    name: item.name ?? item.description ?? item.legalName ?? String(item.id ?? ''),
  }));
  const page = typeof data.page === 'number' ? data.page : data.number ?? 0;
  const size = data.size ?? 20;
  const totalElements = data.totalElements ?? content.length;
  const last = typeof data.last === 'boolean'
    ? data.last
    : page * size + content.length >= totalElements;

  return {
    content,
    totalElements,
    page,
    size,
    last,
  };
};

export default class CoparticipationService {
  constructor() {
    this._statementHttp = new HttpService(COPARTICIPATION_API_BASE);
    this._filterHttp = new HttpService(COPARTICIPATION_FILTER_API_BASE);
  }

  async fetchRecords(params = {}, pageable = {}) {
    return withSuppressedGlobalErrorDialog(() => this._statementHttp.get(
      `${COPARTICIPATION_ENDPOINTS.records}${buildQuery({ ...params, ...pageable })}`,
      null,
    ));
  }

  async exportRecords(params = {}) {
    return withSuppressedGlobalErrorDialog(() => this._statementHttp.post(
      `${COPARTICIPATION_ENDPOINTS.exportReport}${buildQuery(params)}`,
      null,
    ));
  }

  async fetchReports(params = {}) {
    return this._filterHttp.get(COPARTICIPATION_ENDPOINTS.findReport, params);
  }

  async fetchFinancialGroups(page, size, searchText) {
    const params = { page, size };

    if (searchText) {
      params.name = searchText;
    }

    const response = await withSuppressedGlobalErrorDialog(() => this._filterHttp.get(
      `/financial-group/paginated${buildQuery(params)}`,
      {},
    ));

    return normalizePaginatedResponse(response);
  }

  async fetchCarriers(page, size, searchText, financialGroupId) {
    const params = { page, size };

    if (searchText) {
      params.name = searchText;
    }

    if (financialGroupId !== null && financialGroupId !== undefined && financialGroupId !== '') {
      params.financialGroupIds = financialGroupId;
    }

    const response = await withSuppressedGlobalErrorDialog(() => this._filterHttp.get(
      `/carrier/paginated${buildQuery(params)}`,
      {},
    ));

    return normalizePaginatedResponse(response);
  }

  async fetchContracts(page, size, searchText, financialGroupId) {
    const params = { page, size };

    if (searchText) {
      params.searchByLegalNameOrPolicy = searchText;
    }

    if (financialGroupId !== null && financialGroupId !== undefined && financialGroupId !== '') {
      params.financialGroupId = financialGroupId;
    }

    const response = await withSuppressedGlobalErrorDialog(() => this._filterHttp.get(
      `/contract/paginated${buildQuery(params)}`,
      {},
    ));

    return normalizePaginatedResponse(response);
  }
}
